var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"almox-fornecedor","rota-base":"/admin/almox-fornecedor","titulo":"ALMOXARIFADO — FORNECEDORES","titulo-singular":"Fornecedor","colunas-extras":_vm.colunasExtras}})
}
var staticRenderFns = []

export { render, staticRenderFns }